<template>
  <SAIInput
    :value="value"
    class="q-mt-sm"
    large
    :placeholder="placeholder"
    v-on="$listeners"
    v-bind="$attrs"
  >
    <template v-slot:prepend>
      <QIcon
        class="q-mr-xs"
        color="grey-9"
        size="22px"
        name="eva-person-outline"
      />
    </template>
  </SAIInput>
</template>

<script>
import { QIcon } from 'quasar';
import { SAIInput } from 'ecx.saigon.ui.common';

export default {
  name: 'NameInput',
  props: {
    value: undefined,
    placeholder: {
      type: String,
      default: 'Enter Name'
    }
  },
  components: {
    QIcon,
    SAIInput
  }
};
</script>
